define('models/messages/comments_collection',["backbone",
        "models/messages/comment"
], function (Backbone, CommentItem) {
    var CommentsList = Backbone.Collection.extend({
        url: function () {
            var url = pf.accountsURL + "/Posts/Comments";
            url += "?PPGD=" + this.PPGD + "&Count=" + this.clength + "&incLatest=" + this.cIncLatest + "&showFlaggedItems=" + this.showFlaggedItems + "&retainCount=" + this.retainCount;
            return url;
        },
        model: CommentItem,
        initialize: function (attributes, options) {
            options || (options = {});

            this.clength = options.length;
            this.PPGD = options.PPGD;
            this.cIncLatest = options.incLatest;
            this.showFlaggedItems = false;
            if (options.showFlaggedItems)
                this.showFlaggedItems = options.showFlaggedItems;
            this.retainCount = false;
            if (options.retainCount)
                this.retainCount = options.retainCount;

        }
    });
    
    return CommentsList;
});

